import api from './request'

export const baseurl='http://gyxf.cuc.edu.cn';
//export const baseurl='http://localhost:5005';

export const login=(logindata:any)=>{   
    return api.post(baseurl+'/api/login?tmsite='+Math.random(),logindata);
}
export const getStudent=()=>{
    return api.get(baseurl+'/api/student/getstudent?tmsite='+Math.random());
};
export const getRoomStudent=(param:any,grade:any)=>{
    return api.get(baseurl+'/api/student/getRoomStudent?room='+param+'&grade='+grade+'&tmsite='+Math.random());
};
export const getInfoBaseByType=(param:any)=>{
    return api.get(baseurl+'/api/Site/GetInfoBaseByType?type='+param+'&tmsite='+Math.random());
};

export const GetWebSiteSet=()=>{
    return api.get(baseurl+'/api/Site/GetWebSiteSet?tmsite='+Math.random());
};
export const GetHouseList=()=>{
    return api.get(baseurl+'/api/student/GetHouseList?tmsite='+Math.random());
};
export const UpdatePassword=(param:any)=>{
    return api.post(baseurl+'/api/updatepassword',param);
};

export const SaveSelectHouse=(param:any)=>{
    return api.post(baseurl+'/api/student/SaveSelectHouse',param);
};

export const GetDbook=(param:any)=>{
    return api.get(baseurl+'/api/Site/getDBbook?DType='+param+'&tmsite='+Math.random());
};
export const GetStudentXG=(param:any)=>{
    return api.get(baseurl+'/api/Site/GetStudentXG?id='+param+'&tmsite='+Math.random());
};

export const SaveStudentInfo=(param:any)=>{
    return api.post(baseurl+'/api/student/SaveStudentInfo',param);
};

export const InsertPicture=(param:any)=>{
    return api.post(baseurl+'/upimg/InsertPicture',param);
};

export const selecthose=()=>{
    return api.get(baseurl+'/api/student/getHouse?tmsite='+Math.random());
};

export const getTime=()=>{
    return api.get(baseurl+'/api/student/getTime?tmsite='+Math.random());
};

export const GetSetTime=()=>{
    return api.get(baseurl+'/api/Site/GetSetTime?tmsite='+Math.random());
};

export const GetCharts=()=>{
    return api.get(baseurl+'/api/student/GetCharts?tmsite='+Math.random());
};
